// src/signals/search-form-next-page-signal.ts
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { Signal } from "@shared-ui/core-signal-manager/spi";
var SEARCH_FORM_NEXT_PAGE = "SEARCH_FORM_NEXT_PAGE";
var SearchFormNextPageSignal = /*#__PURE__*/ function(Signal) {
    "use strict";
    _inherits(SearchFormNextPageSignal, Signal);
    var _super = _create_super(SearchFormNextPageSignal);
    function SearchFormNextPageSignal() {
        _class_call_check(this, SearchFormNextPageSignal);
        return _super.apply(this, arguments);
    }
    return SearchFormNextPageSignal;
}(Signal);
// src/signals/search-form-location-field-update-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var SEARCH_FORM_LOCATION_FIELD_UPDATE = "SEARCH_FORM_LOCATION_FIELD_UPDATE";
var SearchFormLocationFieldUpdateSignal = /*#__PURE__*/ function(Signal2) {
    "use strict";
    _inherits(SearchFormLocationFieldUpdateSignal, Signal2);
    var _super = _create_super(SearchFormLocationFieldUpdateSignal);
    function SearchFormLocationFieldUpdateSignal() {
        _class_call_check(this, SearchFormLocationFieldUpdateSignal);
        return _super.apply(this, arguments);
    }
    return SearchFormLocationFieldUpdateSignal;
}(Signal2);
export { SEARCH_FORM_LOCATION_FIELD_UPDATE, SEARCH_FORM_NEXT_PAGE, SearchFormLocationFieldUpdateSignal, SearchFormNextPageSignal };
//# sourceMappingURL=index.js.map